import { Link } from "react-router-dom";
import { useTheme } from "@/lib/ThemeContext";

/**
 * Footer with legal links — visible on every page (logged in or out).
 * Uses theme tokens so it adapts to all 7 presets.
 */
export default function LegalFooter() {
  const { tokens: t } = useTheme();
  const year = new Date().getFullYear();

  return (
    <footer
      className="w-full px-4 sm:px-6 py-4 mt-8"
      style={{
        background: "var(--tm-bg-primary, " + t.bgPrimary + ")",
        borderTop: `1px solid var(--tm-border-color, ${t.borderColor})`,
        color: "var(--tm-text-muted, " + t.textMuted + ")",
      }}
      data-testid="legal-footer"
    >
      <div
        className="mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-xs"
        style={{ maxWidth: "var(--max-app-w, 1400px)" }}
      >
        <span style={{ letterSpacing: "0.02em" }}>
          © {year} The Accumulation Group · MMNTM
        </span>
        <nav className="flex items-center gap-3" aria-label="Legal links">
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:underline"
            style={{ color: "var(--tm-text-secondary, " + t.textSecondary + ")" }}
          >
            Terms of Service
          </Link>
          <span aria-hidden style={{ color: "var(--tm-border-color)" }}>·</span>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:underline"
            style={{ color: "var(--tm-text-secondary, " + t.textSecondary + ")" }}
          >
            Privacy Policy
          </Link>
          <span aria-hidden style={{ color: "var(--tm-border-color)" }}>·</span>
          <Link
            to="/security"
            data-testid="footer-security-link"
            className="hover:underline"
            style={{ color: "var(--tm-text-secondary, " + t.textSecondary + ")" }}
          >
            Security
          </Link>
          <span aria-hidden style={{ color: "var(--tm-border-color)" }}>·</span>
          <Link
            to="/status"
            data-testid="footer-status-link"
            className="hover:underline"
            style={{ color: "var(--tm-text-secondary, " + t.textSecondary + ")" }}
          >
            Status
          </Link>
        </nav>
      </div>
    </footer>
  );
}
